import { withStateHandlers, compose } from 'recompose';

const initialState = {
  profileHidden: true
};

const onFocus = props => event => ({ profileHidden: false });
const onBlur = props => event => ({ profileHidden: true });

export default compose(withStateHandlers(initialState, { onFocus, onBlur }));
